import React from 'react'
import WaitingRoomPersonIcon from './WaitingRoomPersonIcon'
import WaitingRoomCandidateInfoPopover from './WaitingRoomCandidateInfoPopover'
import {
  getListRowClass,
  getCandidateStatusClass,
  getPersonNameClass,
} from './coachDashboardStyles'

const getCandidateStatusText = (candidate, t) => {
  if (candidate.presence?.show === 'dnd') {
    if (candidate.presence?.status === 'Chat Ended') {
      return t('coach_dashboard.candidate_chat_ended', 'Chat Ended')
    }
    return t('coach_dashboard.candidate_in_chat', 'In Chat')
  }

  if (candidate.presence?.show === 'away') {
    if (candidate.presence?.status === 'Chat Ended') {
      return t('coach_dashboard.candidate_chat_ended', 'Chat Ended')
    }
    return (
      candidate.presence?.status || t('coach_dashboard.candidate_away', 'Away')
    )
  }

  if (candidate.status === 'chat') {
    return (
      candidate.presence?.status ||
      t('coach_dashboard.candidate_starting_chat', 'Starting Chat')
    )
  }

  return (
    candidate.presence?.status ||
    t('coach_dashboard.candidate_online', 'Online')
  )
}

const CandidateListItem = ({
  candidate,
  embedded,
  chatManager,
  getDarkModeClasses,
  t,
}) => {
  const statusText = getCandidateStatusText(candidate, t)
  const displayName = chatManager?.resolveCandidateDisplayName
    ? chatManager.resolveCandidateDisplayName(candidate)
    : candidate.displayName || candidate.username

  const rowClass = embedded
    ? getListRowClass(getDarkModeClasses)
    : `flex items-center justify-between border-b py-2 last:border-b-0 ${getDarkModeClasses(
        'border-gray-100',
        'border-gray-700',
      )}`

  const nameClass = embedded
    ? getPersonNameClass(getDarkModeClasses)
    : `truncate font-['Roboto'] text-base font-normal ${getDarkModeClasses(
        'text-[#2f2f2f]',
        'text-gray-200',
      )}`

  const statusClass = `truncate ${getCandidateStatusClass(getDarkModeClasses)} text-xs`

  return (
    <div className={rowClass}>
      <div className="flex min-w-0 flex-1 items-center gap-2">
        <WaitingRoomPersonIcon />
        <div className="min-w-0">
          <div className={nameClass}>{displayName}</div>
          <div className={statusClass}>{statusText}</div>
        </div>
      </div>
      <WaitingRoomCandidateInfoPopover candidate={candidate} />
    </div>
  )
}

export default CandidateListItem
